/* eslint-disable max-len */
interface IVerifiedUserIcon {
  userName?: string;
}

const VerifiedUserIcon = ({ userName = "Username" }: IVerifiedUserIcon) => {
  return (
    <div
      title="Verified creator"
      className="verifiedTick"
      style={{
        marginLeft: "4px",
        background: "transparent",
        display: "inline-block"
      }}
    >
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>{`${userName} is a verified Redgifs creator`}</title>
        <circle cx="10" cy="10" r="10" fill="url(#paint0_linear_1451_38763)"/>
        <path d="M5.88281 10.8824L8.0033 13.2836C8.39679 13.7291 9.08977 13.7351 9.49088 13.2964L14.1181 8.23535" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
        <defs>
          <linearGradient id="paint0_linear_1451_38763" x1="10" y1="0" x2="10" y2="20" gradientUnits="userSpaceOnUse">
            <stop stopColor="#8F2CF2"/>
            <stop offset="1" stopColor="#CD4CFF"/>
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default VerifiedUserIcon;
